module.exports = __webpack_public_path__ + "static/media/dark_blue_swoop.e8a088da.png";